export default __webpack_public_path__ + "img/85b3b15073fb439d3168b0a7e5ed333d.png";